import styled from 'styled-components';

export { Notice } from '../semcore';
export const ErrorTitle = styled.h5`
    margin-bottom: calc(var(--baseline) / 2);
    line-height: 1;
`;
